<div class="page-title-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-text">
                    <h2>FAQs</h2>
                    <ul>
                        <li><a routerLink="/">ACCUEIL</a></li>
                        <li><i class="icofont-simple-right"></i></li>
                        <li>FAQs</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Main Content -->
<section class="main-content pt-100">
    <div class="container pt-100 pb-100">
        <!-- Introduction -->
        <div class="row mb-5">
            <div class="col-lg-12 mx-auto">
                <div class="intro-card">
                    <div class="card-icon">
                        <i class="icofont-question-circle"></i>
                    </div>
                    <h2>Besoin d'aide ?</h2>
                    <p>
                        Consultez notre FAQ pour trouver rapidement les informations dont vous avez besoin. 
                        Si vous ne trouvez pas votre réponse, n'hésitez pas à nous contacter.
                    </p>
                </div>
            </div>
        </div>

        <!-- FAQ Section -->
        <div class="row">
            <div class="col-lg-12 mx-auto">
                <div class="faq-container">
                    <!-- Skeleton Loading -->
                        <ng-container *ngIf="!faqs">
                        <div class="faq-skeleton" *ngFor="let item of [].constructor(10)">
                            <div class="skeleton-question">
                                <p-skeleton height="2rem" width="80%" styleClass="mb-2"></p-skeleton>
                            </div>
                            <div class="skeleton-answer">
                                <p-skeleton width="100%" height="1.5rem" styleClass="mb-2"></p-skeleton>
                                <p-skeleton width="90%" height="1.5rem" styleClass="mb-2"></p-skeleton>
                                <p-skeleton width="95%" height="1.5rem" styleClass="mb-2"></p-skeleton>
                            </div>
                        </div>
                        </ng-container>
                        
                    <!-- FAQ Content -->
                        <ng-container *ngIf="faqs">
                        <div class="faq-item" *ngFor="let faq of faqService.value; let i = index">
                            <div class="faq-question" (click)="toggleFaq(i)">
                                <div class="question-content">
                                    <div class="question-icon">
                                        <i class="icofont-question"></i>
                                    </div>
                                    <h3>{{ faq.question }}</h3>
                                </div>
                                <div class="question-arrow">
                                    <i class="icofont-simple-down" [class.rotated]="activeFaq === i"></i>
                                </div>
                            </div>
                            <div class="faq-answer" [class.show]="activeFaq === i">
                                <div class="answer-content" [innerHTML]="faq.remark"></div>
                            </div>
                        </div>
                        </ng-container>
                </div>
            </div>
        </div>

        <!-- Contact Section -->
        
    </div>
    <div class="row mt-5">
        <div class="col-lg-12 text-center">
            <div class="contact-section">
                <h3>Vous ne trouvez pas votre réponse ?</h3>
                <p>Notre équipe est là pour vous aider. Contactez-nous directement.</p>
                <div class="contact-buttons">
                    <a routerLink="/contact" class="btn btn-primary">
                        <i class="icofont-envelope"></i>
                        Nous contacter
                    </a>
                    <a routerLink="/create-account" class="btn btn-outline-primary">
                        <i class="icofont-user-plus"></i>
                        Rejoindre BSTP
                    </a>
                </div>
            </div>
        </div>
    </div>
</section>